exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#servitudeSymbologyModal .v--modal-box.v--modal{min-height:270px!important;min-width:400px!important}#servitudeSymbologyModal .modal__content{margin-top:-60px}#servitudeSymbologyModal .modal__footer{display:none}.select__wrapper{width:100%}#servitudeSymbologyModal .v-select__selections,#servitudeSymbologyModal .v-text-field__slot input{font-size:12px}#servitudeSymbologyModal .color__box{height:20px;width:20px;border:2px solid hsla(0,0%,48%,.8);border-radius:4px;box-sizing:border-box;background-color:aqua}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-59731570","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/servitude/modals/ServitudeSymbology.vue
// module id = 1904
// module chunks = 0